import { List, Map } from "immutable"
import { Action, AsyncState, Fun, mk_pair, none, Option, Pair, unloadedAsyncState, Widget } from "widgets-for-react"
import { getCookieStatus } from "./cms/blocks/cookiebar.utils.mod"
import { TemplateState } from "./cms/page/types.gen"
import { PageTemplateState } from "./cms/state/types.gen"
import { get_options, get_page, InitPagesStates, PublicSite_CustomPageData } from "./public_site/application.mod"
import { CustomBlockData } from "./public_site/blocks/custom_blocks/types.mod"
import { blocks_renderer } from "./public_site/blocks/renderer.mod"
import { CustomPagesState } from "./public_site/custom_pages/types.mod"
import { ExtraImages } from "./public_site/utils/extra_images.mod"
import { CustomBlock } from "./wordpress/types_and_parser/custom_blocks.gen"
import { Breadcrumb } from "./wordpress/types_and_parser/extra_types.mod"
import { Block } from "./wordpress/types_and_parser/standard_blocks.gen"
import { ParsedNode } from "./wordpress/types_and_parser/types.mod"
import { WordPress } from "./wordpress/wordpress_api"
import { Link } from "./cms/blocks/types.gen";
import { PageHeaderProps } from "./public_site/templates/page_header.mod";
import { PageHeaderFooterProps } from "./public_site/templates/page.mod"

export type HeaderMenuLink = { kind: 'link' } & Link

export type HeaderMenuBlocks = {
  kind: 'blocks'
  open: boolean
  title: string
  blocks: List<HeaderMenuBlockItem>
}

export type HeaderMenuBlockItem = {
  subtitle: string
  title: string
  text: string
} & HeaderAccountMenuBlockItem

export type HeaderAccountMenuBlockItem = {
  link: Link
}

export type HeaderAccountMenu = {
  kind: 'account'
  items: HeaderAccountMenuBlockItem[]
  open: boolean
}

export type HeaderMenuLinkList = {
  kind: 'linkList'
  open: boolean
  title: string
  list: List<HeaderMenuLinkListItem>
}

export type HeaderMenuLinkListItem = {
  title: string
  text?: string
  links: List<Link>
}

export type HeaderMenuItem = HeaderMenuLink | HeaderMenuBlocks | HeaderMenuLinkList
export type HeaderMenuItems = Map<number, HeaderMenuItem>
export type HeaderMenus = {
  headerMenuItems: HeaderMenuItems
  account: HeaderAccountMenu
}

export type HeaderState = {
  open: boolean
  menu: AsyncState<HeaderMenus>
  breadcrumb: AsyncState<List<{}>>
}

export type CookieState = {
  cookiebar: "closed" | "open"
}

export type FooterState = {
  menu_footer: FooterMenus
}

export type FooterMenus = {}

export type BrowserState = {
  viewport: "mobile" | "tablet" | "desktop" | "large"
}

export type OptionsState = AsyncState<WordPress.OptionsResponse>

export type PublicSiteState = {
  header: HeaderState
  cookiebar: CookieState
  footer: FooterState
  browser: BrowserState
  options: OptionsState
} & PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData> &
  CustomPagesState

export const defaultPage: ContentType = x => x

export type ContentType = (
  placeholder: Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>
) => Widget<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>

let initPagesStates = InitPagesStates(blocks_renderer<CustomBlockData, ExtraImages>())

export const emptyAppState = (page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, Fun<PageHeaderFooterProps<ExtraImages>, ContentType>>): PublicSiteState =>
  ({
    ...initPagesStates,
    page: {
      ...initPagesStates.page,
      get_page: get_page,
      display: page(mk_pair(List(), none()))({ header: { kind: 'empty'}, footer: { kind: 'empty' } })
    },
    browser: {
      viewport: "desktop"
    },
    header: {
      open: false,
      menu: unloadedAsyncState(),
      breadcrumb: unloadedAsyncState(),
    },
    cookiebar: {
      cookiebar: getCookieStatus() != "undecided" ? "closed" : "open"
    },
    footer: {
      menu_footer: {}
    },
    options: get_options("options")
  } as PublicSiteState)
